import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowCompanyProps as Props } from './types';
import type { CompanyProfile } from '../../../types/companyDetail';
import { getCompanyProfile } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [profile, setProfile] = useState<CompanyProfile>({
    informationTitle: '',
    informationDescription: '',
    informationImage1: null,
    informationImage1Description: '',
    informationImage2: null,
    informationImage2Description: '',
    missionTitle: '',
    missionDescription: '',
    missionImage1: null,
    missionImage1Description: '',
    missionImage2: null,
    missionImage2Description: '',
    coverRecruitmentImg: ''
  });

  useEffect(() => {
    const request = async () => {
      try {
        const response = await getCompanyProfile(props.companyId);
        setProfile(response);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [props.companyId]);

  return (
    <Presentation
      {...props}
      profile={profile}
    />
  );
};
